/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { NumericDiff } from "components/search/input/DifferencePanel/common";
import { NameBasedProductGroupPlanItem } from "store/api/generatedApi";

import { CategoryConfigFactory } from "components/search/input/DifferencePanel/common";

export const ProductionGroupConfigFactory: CategoryConfigFactory<
  NameBasedProductGroupPlanItem
> = ({ t, formatNumber2DP }) => ({
  num_heats: {
    title: t("heats"),
    format: (val) => val,
    renderDiff: ({ updatedVal, previousVal }) => (
      <NumericDiff
        previous={previousVal ?? 0}
        updated={updatedVal ?? 0}
        format={formatNumber2DP}
      />
    ),
  },
});
